import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { EasyEatHqService } from '../services/ee-hq.service';

@Injectable({
  providedIn: 'root',
})
export class HqAccessGuardService implements CanActivate {
  constructor(private _router: Router, private HqService: EasyEatHqService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.HqService.isHqUser()) {
      if (this._router.url.includes('/hq')) {
        return true;
      } else {
        // navigate to HQ home page
        this._router.navigate(['/hq/dashboard']);
        return false;
      }
    } else if (!this.HqService.isHqUser()) {
      return true;
    }
  }
}
